import React from 'react'

export const formatBytes = (bytes) => {
  if (!bytes || bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export const formatSpeed = (bytesPerSecond) => {
  if (!bytesPerSecond || bytesPerSecond <= 0) return '--'
  return formatBytes(bytesPerSecond) + '/s'
}

export const formatTime = (seconds) => {
  if (!seconds || seconds <= 0 || !Number.isFinite(seconds)) return '--'
  if (seconds < 60) {
    return `${Math.round(seconds)}s`
  }
  const minutes = Math.floor(seconds / 60)
  const secs = Math.round(seconds % 60)
  return `${minutes}m ${secs}s`
}

const UploadStats = ({ uploadStats }) => {
  if (!uploadStats || uploadStats.progress <= 0) return null

  return (
    <div className="mt-3 p-3 bg-light rounded">
      <div className="row text-center">
        <div className="col-4">
          <div className="small text-muted">Speed</div>
          <div className="fw-bold">{formatSpeed(uploadStats.uploadSpeed)}</div>
        </div>
        <div className="col-4">
          <div className="small text-muted">Uploaded</div>
          <div className="fw-bold">
            {formatBytes(uploadStats.uploadedBytes)} / {formatBytes(uploadStats.totalBytes)}
          </div>
        </div>
        <div className="col-4">
          <div className="small text-muted">Time Remaining</div>
          <div className="fw-bold">{formatTime(uploadStats.timeRemaining)}</div>
        </div>
      </div>
    </div>
  )
}

export default UploadStats
